import { User, UserPartner, UserProfile, UserRole } from 'shared/types/user'

import { SuccessResponse } from '../../auth.types'

export type GetUserResponse = SuccessResponse<
  Pick<
    User,
    | 'id'
    | 'name'
    | 'organization_id'
    | 'classic'
    | 'container_user_tour_completed'
    | 'container_user_survey_completed'
  > & {
    partners: UserPartner[]
    twofa_enabled: boolean
    roles: Array<{
      id: number
      name: UserRole
      display_name: string
      description: string | null
      color: string | null
    }>
    teams: Array<{
      id: number
      name: string
      department_id: number | null
      in_statistics: number | null
      is_leader: number
      source: string | null
      external_id: string | null
    }>
    profile:
      | (UserProfile & {
          mobile_phone: string
          working_phone: string
          website: string | null
          address: string | null
          house_number: string
          zip_code: string | null
          city: string | null
          country_code: string | null
          external_model_type: string
          external_model_id: number
          language: string
        })
      | null
  }
>

export interface GetUserRequest {
  id: number
}
